import { FormProfileAdminLayout, MenuLayout } from "../layouts";

export const EditProfilePage = () => {
  return (
    <>
      <MenuLayout>
        <FormProfileAdminLayout
          isEditMode={true}
          titlePage="Edición de Perfil"
        />
      </MenuLayout>
    </>
  );
};
